import React from 'react';

const NoPickIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props?.size || "64"} height={props?.size || "64"} viewBox="0 0 64 64" {...props}>
        <g fill="none" fillRule="evenodd">
        <g>
            <g>
                <g>
                    <g>
                        <g transform="translate(-967 -847) translate(110 486) translate(0 45) translate(30 291) translate(827 25)">
                            <circle cx="32" cy="32" r="29" stroke="#F2F2F2" strokeWidth="6"/>
                            <rect width="34" height="8" x="15" y="28" fill="#F2F2F2" rx="2"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export default NoPickIcon;